/**
 * Texture tile constants, shared by the renderer and the UI.
 *
 * A tile is one 16x16 block texture. The GPU receives them as layers of a
 * texture array (which is what lets greedy-merged quads tile correctly); the
 * inventory draws them from a 2D sheet. Same pixels, two consumers.
 */

export const TILE_PX = 16;

/**
 * How many tiles the atlas actually paints. Layer index == tile index.
 * Kept exact rather than rounded up to the sheet size, so a block pointing at
 * an unpainted tile fails a test instead of rendering as nothing.
 */
export const TILE_COUNT = 202;

/**
 * Columns and rows of the 2D sheet used for inventory icons.
 *
 * Fourteen holds 196, against the 174 painted. It has to be at least the
 * square root of TILE_COUNT, and a test says so: an icon sheet a tile too
 * small silently draws the wrong picture for whatever fell off the end.
 *
 * It went to fourteen when the Змій's луска and the four pieces of armour
 * made out of it arrived - thirteen had held 169 exactly, and the gold bar
 * out of a скарб had taken the last of those. It has to be at least the
 * square root of TILE_COUNT, and a test says so: an icon sheet a tile too
 * small silently draws the wrong picture for whatever fell off the end.
 *
 * **Widening this is not free.** `paintTile` seeds its grain from where a
 * tile sits in the sheet, so every texture in the game comes out faintly
 * different - the same blocks, differently freckled. It went from twelve to
 * thirteen when fire arrived, which is when the drone's three tiles had to
 * move up out of the way of the flames'.
 */
/*
 * Fifteen since порох, гума and the снаряд: fourteen held 196 and the tiles
 * reached 198. Widening it re-seeds every tile's grain - see the note above
 * - so the whole world is freckled slightly differently than it was, and
 * nothing else about it moves.
 */
export const ATLAS_TILES = 15;
